import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const usePersistentFilters = (initialFilters, storageKey = 'filters') => {
    const history = useHistory();
    const { search } = useLocation();
    const navLocation = history.location.pathname;
    const user = useSelector(state => state.auth.user);

    function verifyKeepFilters() {
        const previousNavPath = sessionStorage.getItem('previousRoute');

        if (!previousNavPath) return false;

        // Verifica se esta retornando no mesmo escopo -> Ex. navegando de /clientes/1/dependentes/4 → /clientes
        return previousNavPath.startsWith(navLocation);
    }

    const [filters, setFilters] = useState(() => {

        const owner = sessionStorage.getItem("ownerFilters");
        const params = new URLSearchParams(search);
        const cleanFilters = params.get('cleanFilters');

        if (!user || !user.username || user.username !== owner || cleanFilters) {
            sessionStorage.removeItem(storageKey);
            return initialFilters;
        }

        const savedFilters = sessionStorage.getItem(storageKey);
        const keepFilters = verifyKeepFilters();

        try {
            // Mantém filtros se voltar no mesmo escopo
            if (keepFilters && savedFilters && savedFilters !== 'undefined') {
                return JSON.parse(savedFilters);
            }
        } catch (error) {
            console.warn('Erro ao restaurar filtros:', error);
        }

        // Qualquer outro caso → limpa
        sessionStorage.removeItem(storageKey);
        return initialFilters;
    });

    // Atualiza sempre que mudar o usuário
    useEffect(() => {
        const owner = sessionStorage.getItem("ownerFilters");
        const params = new URLSearchParams(search);
        const cleanFilters = params.get('cleanFilters');
        if (user.username !== owner || cleanFilters) {
            clearAllFilters();
            sessionStorage.setItem("ownerFilters", user.username);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        sessionStorage.setItem(storageKey, JSON.stringify(filters));
        sessionStorage.setItem('previousRoute', navLocation);
    }, [filters, navLocation, storageKey]);

    const resetFilters = () => {
        sessionStorage.removeItem(storageKey);
        setFilters(initialFilters);
    };

    function clearAllFilters() {
        // Percorre todas as chaves do sessionStorage
        Object.keys(sessionStorage).forEach((key) => {
            if (key.toLowerCase().includes('filters')) {
                sessionStorage.removeItem(key);
            }
        });
        setFilters(initialFilters);
    }

    return [filters, setFilters, resetFilters, clearAllFilters];
};